import AppRecord from './AppRecord.js'
import APP from 'src/main.js'
class Covariance extends AppRecord {
  get issue_x(){
    return this.constructor.employeeStore.issues.find(isx => isx.id === this.x_id)
  }
  get issue_x_name(){
    if(this.issue_x){
      return this.issue_x.name
    } else {
      return null
    }
  }
  get issue_y(){
    return this.constructor.employeeStore.issues.find(isx => isx.id === this.y_id)
  }
  get issue_y_name(){
    if(this.issue_y){
      return this.issue_y.name
    } else {
      return null
    }
  }
}
export default Covariance
